import { useCallback } from 'react'
import { useQuery } from '@apollo/client/react'
import { useExperiment } from '@fs/zion-experiments'
import { i18n } from '@fs/zion-locale'
import { getEncodedArk, getSearchedImageName } from 'helpers'
import { getImageApidByName } from 'components/FormInputs/queries'
import useGroupSearch from './useGroupSearch'

export default function useImageDetailsUrl(apidData) {
  const { groupSearchQueryParams } = useGroupSearch()
  const { imageApid, imageArk, imageGroupNumbers } = groupSearchQueryParams
  const imageName = getSearchedImageName(imageGroupNumbers)
  const { data: nameApidData } = useQuery(getImageApidByName, {
    variables: { imageName },
    skip: !imageName || Boolean(imageApid || imageArk),
  })
  const [imageDetailsUrlEx] = useExperiment('imageDetailsUrlEx')

  const getReactImageDetailsUrl = useCallback(
    (group) => {
      const id = group?.id
      const imageApids = group?.imageApids || []
      const imageApidsToUse = [...imageApids]
      // Insert the searched for image apid into the start of the array
      const apid = imageApid ?? apidData?.imageApid ?? nameApidData?.imageApidByName
      if (apid) {
        imageApidsToUse.unshift(apid)
      }
      const encodedArk = imageArk || getEncodedArk({ id, imageApids: imageApidsToUse })
      return `${window.location.origin}/ark:/61903/${encodedArk}?view=explore&groupId=${id}&grid=on`
    },
    [apidData, imageApid, imageArk, nameApidData]
  )

  const getImageDetailsUrl = useCallback(
    (group) => {
      const searchParams = new URLSearchParams(groupSearchQueryParams)
      const groupUrl =
        imageDetailsUrlEx || i18n.language !== 'zh'
          ? getReactImageDetailsUrl(group)
          : `${window.location.origin}/records/images/image-details?rmsId=${group.id}&${searchParams.toString()}`
      return groupUrl
    },
    [getReactImageDetailsUrl, groupSearchQueryParams, imageDetailsUrlEx]
  )

  return getImageDetailsUrl
}
